import UpdateKycWizard from "./UpdateKycWizard";
import { withAuthorization } from "../Session";
import { withFirebase } from "../Firebase";

// Mirrors the legacy export: authenticated client route at ROUTES.UPDATE_KYC.
// withAuthorization composes withRouter (history) + withFirebase.
const condition = (authUser: unknown): boolean => !!authUser;

export default withAuthorization(condition)(withFirebase(UpdateKycWizard));
